import { render, staticRenderFns } from "./AdminMes.vue?vue&type=template&id=6b494571&scoped=true"
import script from "./AdminMes.vue?vue&type=script&lang=js"
export * from "./AdminMes.vue?vue&type=script&lang=js"
import style0 from "./AdminMes.vue?vue&type=style&index=0&id=6b494571&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b494571",
  null
  
)

export default component.exports